import { render } from "./Invoices.vue?vue&type=template&id=04a1f113&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=04a1f113&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04a1f113"

export default script